import { render, staticRenderFns } from "./interests.vue?vue&type=template&id=5355deb7&scoped=true"
import script from "./interests.vue?vue&type=script&lang=js"
export * from "./interests.vue?vue&type=script&lang=js"
import style0 from "./interests.vue?vue&type=style&index=0&id=5355deb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5355deb7",
  null
  
)

export default component.exports